module.exports = __webpack_public_path__ + "static/img/status_indication02.3da60ea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/status_indication02.gif
// module id = xFkT
// module chunks = 1